enum ActionTypes {
  SELECT_COMPANY = 'Mandates/New/SELECT_COMPANY',
}

export default ActionTypes;
